import React, { Component } from 'react';
import { Link } from "react-router-dom";
import OrderStatusSelect from '../../common/OrderStatusSelect'
import Pagination from '../../common/Pagination'
import { HttpRequestService } from '../../services/HttpRequestService';
import moment from 'moment'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { UtilsService } from '../../services/UtilsService';
import Checkbox from '../../common/Checkbox';

class WalmartOrderList extends Component {

    constructor(props) {
        super(props);
        this.utils = new UtilsService();
        var initialState = {
            orderStatusId: 1,
            orderNumber: '',
            walmartOrderNumber: '',
            customerNumber: '',
            customerName: '',
            splitOnly: false,
            beginDate: null,
            endDate: null,
            orders: [],
            pageCount: 0,
            pageIndex: 0
        }
        this.paramsKey = "params.walmart-order-list";
        this.state = this.utils.prepareSessionState(initialState, this.paramsKey);
        this.http = new HttpRequestService();
        this.handleOrderStatusChange = this.handleOrderStatusChange.bind(this);
        this.handleOrderNumberChange = this.handleOrderNumberChange.bind(this);
        this.handleWalmartOrderNumberChange = this.handleWalmartOrderNumberChange.bind(this);
        this.handleCustomerNumberChange = this.handleCustomerNumberChange.bind(this);
        this.handleCustomerNameChange = this.handleCustomerNameChange.bind(this);
        this.handleBeginDateChange = this.handleBeginDateChange.bind(this);
        this.handleEndDateChange = this.handleEndDateChange.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
        this.handleSplitOnlyChange = this.handleSplitOnlyChange.bind(this);
        this.pageSize = 50;
        this.getOrders = this.getOrders.bind(this);
    }

    componentDidMount() {
        this.getOrders(this.state.pageIndex);
    }

    handleOrderStatusChange(orderStatusId) {
        this.setState({ orderStatusId: orderStatusId });
    }

    handleOrderNumberChange(e) {
        this.setState({ orderNumber: e.target.value });
    }

    handleWalmartOrderNumberChange(e) {
        this.setState({ walmartOrderNumber: e.target.value });
    }

    handleCustomerNumberChange(e) {
        this.setState({ customerNumber: e.target.value });
    }

    handleCustomerNameChange(e) {
        this.setState({ customerName: e.target.value });
    }

    handleBeginDateChange(e) {
        this.setState({ beginDate: e });
    }

    handleEndDateChange(e) {
        this.setState({ endDate: e });
    }

    handlePageChange(page) {
        this.getOrders(page);
    }

    handleSplitOnlyChange(checked) {
        this.setState({ splitOnly: checked });
    }

    getOrders(page, e) {
        if (!!e) {
            e.preventDefault();
        }
        this.setState({ pageIndex: page });
        var params = {
            orderStatusId: this.state.orderStatusId,
            orderNumber: this.state.orderNumber,
            walmartOrderNumber: this.state.walmartOrderNumber,
            customerNumber: this.state.customerNumber,
            customerName: this.state.customerName,
            splitOnly: this.state.splitOnly,
            beginDate: this.state.beginDate != null ? moment(this.state.beginDate).format('L') : "",
            endDate: this.state.endDate != null ? moment(this.state.endDate).format('L') : "",
            pageSize: this.pageSize,
            pageIndex: page
        }
        sessionStorage.setItem(this.paramsKey, JSON.stringify(params));
        this.http.get('/api/Orders/SearchWalmartOrders', params).then(data => {
            this.setState({ orders: data.data, pageCount: parseInt(Math.ceil(data.count / this.pageSize)) });
        });
    }

    render() {
        return (
            <div className="page-inner">
                <div className="page-header">
                    <h4 className="page-title">Walmart Order List</h4>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <form onSubmit={(e) => this.getOrders(0, e)}>
                                <div className="card-body">
                                    <div className="form-row">
                                        <div className="form-group col-md-3">
                                            <label htmlFor="orderStatus">Order Status</label>
                                            <OrderStatusSelect value={this.state.orderStatusId} onChange={this.handleOrderStatusChange} hasAllOption={true}></OrderStatusSelect>
                                        </div>
                                        <div className="form-group col-md-3">
                                            <label htmlFor="orderNumber">Order Number</label>
                                            <input type="text" className="form-control" value={this.state.orderNumber} onChange={this.handleOrderNumberChange} />
                                        </div>
                                        <div className="form-group col-md-3">
                                            <label htmlFor="orderNumber">Walmart Order Number</label>
                                            <input type="text" className="form-control" value={this.state.walmartOrderNumber} onChange={this.handleWalmartOrderNumberChange} />
                                        </div>
                                    </div>
                                    <div className="form-row">
                                        <div className="form-group col-md-3">
                                            <label htmlFor="customerNumber">Customer Name</label>
                                            <input type="text" className="form-control" value={this.state.customerName} onChange={this.handleCustomerNameChange} />
                                        </div>
                                        <div className="form-group col-md-3">
                                            <label htmlFor="customerNumber">Customer Number</label>
                                            <input type="text" className="form-control" value={this.state.customerNumber} onChange={this.handleCustomerNumberChange} />
                                        </div>
                                        <div className="form-group col-md-3">
                                            <label htmlFor="beginDate">Begin Date</label>
                                            <DatePicker className="form-control" selected={this.state.beginDate} onChange={this.handleBeginDateChange} />
                                        </div>
                                        <div className="form-group col-md-3">
                                            <label htmlFor="endDate">End Date</label>
                                            <DatePicker className="form-control" selected={this.state.endDate} onChange={this.handleEndDateChange} />
                                        </div>
                                    </div>
                                    <div className="form-row">
                                        <div className="form-group col-md-3">
                                            <Checkbox label="Display split orders only" checked={this.state.splitOnly} onChange={this.handleSplitOnlyChange}></Checkbox>
                                        </div>
                                    </div>
                                    <div className="form-row pull-right">
                                        <button type="submit" className="btn btn-primary">Submit</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div className="card">
                            <div className="card-body">
                                <div className="form-row">
                                    <table className="table table-striped mt-3">
                                        <thead>
                                            <tr>
                                                <th scope="col">Order</th>
                                                <th scope="col">Walmart Order Id</th>
                                                <th scope="col">Customer</th>
                                                <th scope="col">Product Charges</th>
                                                <th scope="col">Sales Tax</th>
                                                {/* <th scope="col">Referral Fee</th>
                                                <th scope="col">FBA Pick &amp; Pack Fee</th>
                                                <th scope="col">Other Fees</th>
                                                <th scope="col">Total Fees</th>
                                                <th scope="col">Total</th> */}
                                                <th scope="col">State</th>
                                                <th scope="col">Status</th>
                                                <th scope="col">Date</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.orders.map((order) =>
                                                <tr key={order.orderId}>
                                                    <td><Link to={"/order/" + order.orderId}>{order.orderNumber}</Link></td>
                                                    <td>{order.marketplaceOrderId}</td>
                                                    <td>{order.companyName}</td>
                                                    <td>{this.utils.toCurrency(order.subtotal)}</td>
                                                    <td>{this.utils.toCurrency(order.stateTax)}</td>
                                                    {/* <td>{this.utils.toCurrency(order.referralFee)}</td>
                                                    <td>{this.utils.toCurrency(order.fulfillmentFee)}</td>
                                                    <td>{this.utils.toCurrency(order.otherFees)}</td>
                                                    <td>{this.utils.toCurrency((order.referralFee + order.fulfillmentFee + order.otherFees))}</td>
                                                    <td>{this.utils.toCurrency((order.productCharges - order.referralFee - order.fulfillmentFee - order.otherFees))}</td> */}
                                                    <td>{order.state}</td>
                                                    <td>{order.orderStatus}</td>
                                                    <td>{order.dateTimeStamp}</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        {this.state.orders.length > 0 &&
                                            <Pagination pageIndex={this.state.pageIndex} pageCount={this.state.pageCount} onPageChanged={this.handlePageChange}></Pagination>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default WalmartOrderList;
